<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
      <h2 class="text-xl text-white font-semibold w-fit mb-0">{{ getPageTitle() }}</h2>
    </div>

    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loadingEsims" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="esimList.length > 0 && !loadingEsims"
          filterKeyPrefix="esims"
          [items]="esimList"
          (itemClick)="onEsimClick($event)"
          [filterFields]="filterEsims"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="false"
          (filtersChanged)="onFiltersChanged($event)"
          (filteredCount)="filteredCounts.esimList = $event">

          <ng-template #tableHeaderTemplate>
            <div class="flex items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="w-[90px] truncate text-gray-500 mr-4">{{ 'BACKOFFICE.USERS.ESIM_LIST.PURCHASE' | translate }}</div>
              <div class="w-[100px] truncate text-gray-500 mr-4">{{ 'BACKOFFICE.USERS.ESIM_LIST.STATUS' | translate }}</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">{{ 'BACKOFFICE.USERS.ESIM_LIST.COUNTRY' | translate }}</div>
              <div class="w-[140px] truncate text-gray-500 mr-4">{{ 'BACKOFFICE.USERS.ESIM_LIST.VOICE' | translate }}</div>
              <div class="w-[140px] truncate text-gray-500 mr-4">{{ 'BACKOFFICE.USERS.ESIM_LIST.MESSAGES' | translate }}</div>
              <div class="w-[140px] truncate text-gray-500">{{ 'BACKOFFICE.USERS.ESIM_LIST.DATA' | translate }}</div>
            </div>
          </ng-template>

          <ng-template #itemTemplate let-item>
            <div class="flex items-center border-b py-2 text-sm overflow-x-auto">
              <div class="w-[90px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" *ngIf="item.purchaseDate">{{ item.purchaseDate | date:'dd/MM/yyyy' }}</div>
              <div class="w-[100px] truncate overflow-hidden whitespace-nowrap mr-4">{{ item.status }}</div>
              <div class="w-[90px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" *ngIf="item.activationDate">{{ item.activationDate | date:'dd/MM/yyyy' }}</div>
              <div class="w-[110px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" *ngIf="item.expiryDate">{{ item.expiryDate | date:'dd/MM/yyyy' }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.country }}">{{ item.country }}</div>
              <div class="w-[140px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.voiceUsageDisplay }}">{{ item.voiceUsageDisplay }}</div>
              <div class="w-[140px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.textUsageDisplay }}">{{ item.textUsageDisplay }}</div>
              <div class="w-[140px] truncate overflow-hidden whitespace-nowrap text-gray-500" title="{{ item.dataUsageDisplay }}">{{ item.dataUsageDisplay }}</div>
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.esimList == 0 && !loadingEsims" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">sim_card</mat-icon><br />
              {{ 'BACKOFFICE.USERS.ESIM_LIST.NO_ESIMS_FOUND' | translate }}
            </div>
          </div>
        </app-generic-list>

        </div>
    </div>

    <button mat-button color="primary" (click)="goBack()">{{ 'BACKOFFICE.USERS.PROFILE.BACK' | translate }}</button>

  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
